<router-outlet></router-outlet>
@if (pushNotificationsTwaComponent) {
  <ng-container *ngComponentOutlet="pushNotificationsTwaComponent"></ng-container>
}
